import * as i0 from "@angular/core";
export class FuncionesService {
    constructor() { }
    digitoValido(dv) {
        if (dv != '0' && dv != '1' && dv != '2' && dv != '3' && dv != '4' && dv != '5' && dv != '6' && dv != '7' && dv != '8' && dv != '9' && dv != 'k' && dv != 'K') {
            return false;
        }
        return true;
    }
    quitarFormato(rut) {
        var strRut = new String(rut);
        while (strRut.indexOf(".") != -1) {
            strRut = strRut.replace(".", "");
        }
        while (strRut.indexOf("-") != -1) {
            strRut = strRut.replace("-", "");
        }
        return strRut;
    }
    getDigito(rut) {
        var dvr = '0';
        let suma;
        let mul;
        suma = 0;
        mul = 2;
        let i;
        let res;
        for (i = rut.length - 1; i >= 0; i--) {
            suma = suma + rut.charAt(i) * mul;
            if (mul == 7) {
                mul = 2;
            }
            else {
                mul++;
            }
        }
        res = suma % 11;
        if (res == 1) {
            return 'k';
        }
        else if (res == 0) {
            return '0';
        }
        else {
            return 11 - res;
        }
    }
    digitoCorrecto(crut) {
        let largo;
        let rut;
        let dvr;
        let dv;
        largo = crut.length;
        if (largo < 2) {
            return false;
        }
        if (largo > 2) {
            rut = crut.substring(0, largo - 1);
        }
        else {
            rut = crut.charAt(0);
        }
        dv = crut.charAt(largo - 1);
        this.digitoValido(dv);
        if (rut == null || dv == null) {
            return 0;
        }
        dvr = this.getDigito(rut).toString();
        if (dvr != dv.toLowerCase()) {
            return false;
        }
        return true;
    }
    validarrut(texto) {
        texto = this.quitarFormato(texto);
        let largo;
        largo = texto.length;
        let rutFormateado = "";
        // rut muy corto
        if (largo < 2) {
            return false;
        }
        let i;
        // verifica que los numeros correspondan a los de rut
        for (i = 0; i < largo; i++) {
            // numero o letra que no corresponda a los del rut
            if (!this.digitoValido(texto.charAt(i))) {
                return false;
            }
        }
        var invertido = "";
        let j;
        for (i = (largo - 1), j = 0; i >= 0; i--, j++) {
            invertido = invertido + texto.charAt(i);
        }
        var dtexto = "";
        dtexto = dtexto + invertido.charAt(0);
        dtexto = dtexto + '-';
        let cnt;
        cnt = 0;
        for (i = 1, j = 2; i < largo; i++, j++) {
            if (cnt == 3) {
                dtexto = dtexto + '.';
                j++;
                dtexto = dtexto + invertido.charAt(i);
                cnt = 1;
            }
            else {
                dtexto = dtexto + invertido.charAt(i);
                cnt++;
            }
        }
        invertido = "";
        for (i = (dtexto.length - 1), j = 0; i >= 0; i--, j++) {
            invertido = invertido + dtexto.charAt(i);
        }
        rutFormateado = invertido;
        //alert($scope.rutV);
        //return invertido;
        //console.log(invertido);
        if (this.digitoCorrecto(texto)) {
            return true;
        }
        return false;
    }
}
FuncionesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FuncionesService_Factory() { return new FuncionesService(); }, token: FuncionesService, providedIn: "root" });
